module.exports = __webpack_public_path__ + "img/myMind-gray.0a7bfd41.svg";